var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import { typography } from "../../shared/theme";
import classNames from "classnames";
export const FTLTooltipPopover = (_a) => {
    var { wait = 250, title, className } = _a, otherProps = __rest(_a, ["wait", "title", "className"]);
    const [isShow, setIsShow] = useState(false);
    const classes = useStyles();
    useEffect(() => {
        const id = setTimeout(() => {
            setIsShow(true);
        }, wait);
        return () => clearTimeout(id);
    }, [wait]);
    return isShow ? (React.createElement("div", Object.assign({}, otherProps, { className: classNames(classes.popover, className) }), title)) : null;
};
const useStyles = makeStyles({
    popover: Object.assign({ position: "absolute", backgroundColor: "#132339", padding: "2px 4px", borderRadius: "4px", color: "#fff", maxWidth: 280, zIndex: 1306 }, typography.unsupportedSemanticTags.tooltip),
});
//# sourceMappingURL=index.js.map